import React from 'react';

import { useGetWorkspaceDetail } from '~teacher/hook/workspaces';
import { composePermissions } from '~teacher/hook/workspaces/permissions/composePermissions';
import { useGetWorkspaceRole } from '~teacher/hook/workspaces/useGetWorkspaceRole';

import { WorkspacePermissions } from './types';

const basePermissions: WorkspacePermissions = {
  duplicateQuiz: false,
  downloadQuiz: false,
  moveQuiz: false,
  deleteQuiz: false,
  purgeQuiz: false,
  restoreQuiz: false,
  createQuiz: false,
  editQuiz: false,
  resetInviteLink: false,
  disableInviteLink: false,
  renameWorkspace: false,
  deleteWorkspace: false,
  removeOthers: false,
  transferOwnership: false,
  createFolder: false,
  renameFolder: false,
  deleteFolder: false,
  purgeFolder: false,
  restoreFolder: false,
  toggleReadOnly: false,
  isOwner: false,
};

/**
 * @deprecated use new workspace permissions
 */
export const useWorkspacePermissions = (workspaceId: string) => {
  const [permissions, setPermissions] =
    React.useState<null | WorkspacePermissions>(basePermissions);
  const role = useGetWorkspaceRole({ workspaceId });
  const mode = useGetWorkspaceDetail({ workspaceId });
  // set the computed permissions
  React.useEffect(() => {
    if (role.data && mode.data) {
      // we got the data
      const perms = composePermissions(mode.data.mode, role.data.role);
      setPermissions(perms);
    }
  }, [role.data, mode.data]);
  /**
   * Skeleton Controller
   * - We want the skeleton controller to be visible for at least 100ms while data is being fetched
   */
  const [isLoading, setIsLoading] = React.useState(false);
  const timeout = React.useRef(null);
  React.useEffect(() => {
    if (timeout.current) return;
    setIsLoading(true);
    // once some data is received
    if (!role.isLoading && !mode.isLoading) {
      setIsLoading(true);
      // sometimes the request is really, really fast, and the skeleton appears for 10ms
      // to combat this, it will be shown for at least 100ms
      timeout.current = setTimeout(() => {
        setIsLoading(false);
      }, 100);
    }
  }, [mode.isLoading, role.isLoading]);
  return { isLoading, permissions };
};
